import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Dadata2Service } from '../../../services/dadata2.service';
import { ValidationService } from '../validation.service';
import {environment} from "../../../../environments/environment";
import detectMobile from "../../../utils/detect-mobile";

@Component({
  selector: 'app-autocomplete-email',
  templateUrl: './autocomplete-email.component.html',
  styleUrls: ['./autocomplete-email.component.sass'],
})
/**
 * новый компонент автокомплита под primeng
 */
export class AutocompleteEmailComponent {
  public results = [];

  public brand;

  public isMobile;

  @Input() fieldName: string;
  @Input() label: string;
  @Input() formGroup: FormGroup;
  @Input() disableRequiredIdentifier: boolean = false;
  @Input() disableRequiredIdentifierLabel: boolean = false;

  constructor(private _dadata2: Dadata2Service) {
    this._dadata2.suggestions$.subscribe((r) => (this.results = r));
    this.brand = environment.brand;
    this.isMobile = detectMobile();
  }

  search(event: any) {
    this._dadata2.searchEmail(event.query);
  }

  public get control() {
    return this.formGroup.get(this.fieldName) as FormControl;
  }

  public validation() {
      return ValidationService.getValidationClass(
        this.formGroup.get(this.fieldName) as FormControl, this.brand, this.disableRequiredIdentifier
      );
  }

  public formatFieldName(title) {
    return  this.isMobile && this.disableRequiredIdentifierLabel ? title + '*' : title
  }
}
